import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=982a9af6&scoped=true"
import script from "./ImageItem.vue?vue&type=script&lang=js"
export * from "./ImageItem.vue?vue&type=script&lang=js"
import style0 from "./ImageItem.vue?vue&type=style&index=0&id=982a9af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982a9af6",
  null
  
)

export default component.exports